// extracted by mini-css-extract-plugin
export var accordion = "faq-module--accordion--88154";
export var custom = "faq-module--custom--1a004";
export var description = "faq-module--description--9f006";
export var heading = "faq-module--heading--3a2a0";